var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-wrapper"},[_vm._m(0),_c('p',{staticClass:"thank-you"},[_vm._v(" "+_vm._s(_vm.$t('thank_you'))+" ")]),_c('p',{staticClass:"thank-you-text"},[_vm._v(" "+_vm._s(_vm.$t('thank_you_text'))+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/images/green-check.svg"),"alt":"Success"}})])
}]

export { render, staticRenderFns }